/* eslint-disable @typescript-eslint/no-explicit-any */
// src/utils/excelHelper.ts
import * as XLSX from 'xlsx';

/**
 * Interface for the imported Excel data
 */
export interface ExcelData {
  [key: string]: unknown; // You can define more specific types based on your Excel structure
}

/**
 * Function to read and extract data from an imported Excel file
 * @param {File} file - The uploaded Excel file
 * @return {Promise<ExcelData[]>} - A promise that resolves to the Excel file's data in JSON format
 */
export const getExcelData = (file: File): Promise<ExcelData[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = event => {
      try {
        const arrayBuffer = event.target?.result as ArrayBuffer;
        const data = new Uint8Array(arrayBuffer);
        const workbook = XLSX.read(data, { type: 'array' });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rawData = XLSX.utils.sheet_to_json<any[]>(worksheet, {
          header: 1,
        });
        resolve(rawData as any);
      } catch (error) {
        reject(error);
      }
    };
    reader.onerror = error => {
      reject(error);
    };
    reader.readAsArrayBuffer(file); // Use readAsArrayBuffer instead
  });
};

export const getExcelDataJson = (file: File): Promise<any[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = event => {
      try {
        const arrayBuffer = event.target?.result as ArrayBuffer;
        const wb = XLSX.read(arrayBuffer, { type: 'array' }); // 'array' instead of 'binary'

        // Get the first sheet from the Excel file
        const ws = wb.Sheets[wb.SheetNames[0]];

        // Convert the sheet to JSON
        const json = XLSX.utils.sheet_to_json(ws);
        resolve(json);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = error => {
      reject(error);
    };

    reader.readAsArrayBuffer(file); // Correct method to use
  });
};
